import React from 'react';
import { useQuery } from '@apollo/client';
import IFieldsetProps from '../../../utils/types/IFieldsetProps';
import { GET_TERMINATION_LIFECYCLE_STATUSES_QUERY } from '../../../utils/statApi/EntityStatusApi';
import QueryBasedDropdown from './queryBasedDropdown/QueryBasedDropdown';
import IDropdownReference from '../../../utils/types/IDropdownReference';

const TerminationLifecycleStateDropdown = (props: IFieldsetProps): JSX.Element => {
  const {
    value,
    label,
    required,
    errors,
    handleChange,
    valueKey,
    outputKey,
    dropdownOptionsData,
    disabled,
    tooltipProps,
  } = props;
  const { loading, data: terminationLifecycleData } = useQuery(
    GET_TERMINATION_LIFECYCLE_STATUSES_QUERY,
  );
  const terminationLifecycleStatuses =
    dropdownOptionsData ??
    (!loading && terminationLifecycleData
      ? terminationLifecycleData.terminationLifecycleStatuses
      : []);

  return (
    <QueryBasedDropdown
      value={value as IDropdownReference}
      label={label}
      required={required}
      outputKey={outputKey}
      dropdownOptionsData={terminationLifecycleStatuses}
      errors={errors}
      handleChange={handleChange}
      valueKey={valueKey}
      disabled={disabled}
      tooltipProps={tooltipProps}
    />
  );
};

export default TerminationLifecycleStateDropdown;
